module.exports = __webpack_public_path__ + "img/er.976db2b7.svg";